import { render, staticRenderFns } from "./PayeeVersionCardContent.vue?vue&type=template&id=2dd607a5&"
import script from "./PayeeVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./PayeeVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports